<template>
    <div class="lxgl_home">
        <div class="lxgl1">
            <img class="l1_img" src="../img/lxgl/banner1.jpg" alt="">
            <div class="l1_div"></div>
        </div>
        <div class="new1" id="new1">
            <div class="n1_cont">
                <div class="section_title">
                    <p class="section_cn">热门国家申请攻略</p>
                    <p class="section_en">APPLICATION REQUIREMENTS</p>
                </div>

                <div class="n1_nav_box">
                    <div class="n1_nav_item" @click="switchCountry(0)">
                        <p>英国</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(1)">
                        <p>美国</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(2)">
                        <p>日本</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(3)">
                        <p>德国</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(4)">
                        <p>加拿大</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(5)">
                        <p>澳大利亚</p>
                    </div>

                </div>
                <div class="n1_main">
                    <div class="n1_main_hid2"></div>
                    <div class="n1_main_hid"></div>
                    <div class="n1_main_show">
                        <div class="n1_main_li_box">
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Frame.png" alt="">
                                <p>申请时间：</p>
                                <div>{{ theCountryData.time }}</div>
                            </div>
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 541.png" alt="">
                                <p>语言要求：</p>
                                <div>{{ theCountryData.language }}</div>
                            </div>
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 542.png" alt="">
                                <p>申请材料：</p>
                                <div>{{ theCountryData.writ }}</div>
                            </div>
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 543.png" alt="">
                                <p>绩点要求：</p>
                                <div>{{ theCountryData.gpa }}</div>
                            </div>

                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 544.png" alt="">
                                <p>文书要求：</p>
                                <div>{{ theCountryData.material }}</div>
                            </div>

                        </div>
                        <div class="n1_main_bottom_box">

                            <!-- <div >
                                <p>即刻咨询</p>
                                <img src="../img/留学资讯切图/Group 545.png" alt="">
                            </div> -->
                            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                <div class="n1_main_bottom_item2" @mouseenter="moreEnter" @mouseleave="moreLeave">
                                    <p id="n1_main_bottom_item_p2">了解更多</p>
                                    <img src="../img/热门专业切图/Group 522.png" alt="">
                                </div>
                            </a>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div class="lxgl2">
            <div class="section_title">
                <p class="section_cn">热门学校推荐</p>
                <p class="section_en">SCHOOL RECOMMENDATION</p>
            </div>

            <div class="l2_cont" style="display: flex;">
                <div class="l2_item">
                    <img src="../img/lxgl/11.jpg" alt="">
                    <p class="p1">伦敦艺术大学</p>
                    <p class="p2">University of the Arts London</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/12.jpg" alt="">
                    <p class="p1">皇家艺术学院</p>
                    <p class="p2">Royal College of Art</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/13.jpg" alt="">
                    <p class="p1">爱丁堡大学</p>
                    <p class="p2">The University of Edinburgh</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/14.jpg" alt="">
                    <p class="p1">伦敦大学金史密斯学院</p>
                    <p class="p2">Goldsmiths, University of London</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/15.jpg" alt="">
                    <p class="p1">利兹大学</p>
                    <p class="p2">University of Leeds</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/16.jpg" alt="">
                    <p class="p1">金斯顿大学</p>
                    <p class="p2">Kingston University</p>
                </div>
            </div>
            <!-- 2 -->
            <div class="l2_cont">
                <div class="l2_item">
                    <img src="../img/lxgl/21.jpg" alt="">
                    <p class="p1">罗德岛设计学院</p>
                    <p class="p2">Rhode Island School of Design</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/22.jpg" alt="">
                    <p class="p1">帕森斯设计学院</p>
                    <p class="p2">Parsons the New School for Design</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/23.jpg" alt="">
                    <p class="p1">普瑞特艺术学院</p>
                    <p class="p2">Pratt Institute</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/24.jpg" alt="">
                    <p class="p1">马里兰艺术学院</p>
                    <p class="p2">Maryland Institute College of Art</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/25.jpg" alt="">
                    <p class="p1">萨凡纳艺术与设计学院</p>
                    <p class="p2">Savannah College of Art and Design</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/26.jpg" alt="">
                    <p class="p1">纽约时装学院</p>
                    <p class="p2">Fashion Institute of Technology State University of New York</p>
                </div>
            </div>
            <!-- 3 -->
            <div class="l2_cont">
                <div class="l2_item">
                    <img src="../img/lxgl/31.jpg" alt="">
                    <p class="p1">武藏野美术大学</p>
                    <p class="p2">Musashino Art University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/32.jpg" alt="">
                    <p class="p1">多摩美术大学</p>
                    <p class="p2">Tama Art University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/33.jpg" alt="">
                    <p class="p1">东京造型大学</p>
                    <p class="p2">Tokyo Zokei University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/34.jpg" alt="">
                    <p class="p1">京都艺术大学</p>
                    <p class="p2">Kyoto University of Art and Design</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/35.jpg" alt="">
                    <p class="p1">京都精华大学</p>
                    <p class="p2">Kyoto Seika University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/36.jpg" alt="">
                    <p class="p1">女子美术大学</p>
                    <p class="p2">JOSHIBI UNIVERSITY OF ART AND DESIGN</p>
                </div>
            </div>
            <!-- 4 -->
            <div class="l2_cont">
                <div class="l2_item">
                    <img src="../img/lxgl/41.jpg" alt="">
                    <p class="p1">柏林大学</p>
                    <p class="p2">Universität zu Berlin</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/42.jpg" alt="">
                    <p class="p1">柏林艺术大学</p>
                    <p class="p2">Universität der Künste Berlin</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/43.jpg" alt="">
                    <p class="p1">柏林工业大学</p>
                    <p class="p2">Berlin Institute of Technology</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/44.jpg" alt="">
                    <p class="p1">柏林媒体设计学院</p>
                    <p class="p2">Mediadesign Hochschule MD.H</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/45.jpg" alt="">
                    <p class="p1">柏林自由大学</p>
                    <p class="p2">Freie Universität Berlin, FU Berlin</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/46.jpg" alt="">
                    <p class="p1">卡塞尔大学</p>
                    <p class="p2">Kunsthochschule Kassel</p>
                </div>
            </div>
            <!-- 5 -->
            <div class="l2_cont">
                <div class="l2_item">
                    <img src="../img/lxgl/51.jpg" alt="">
                    <p class="p1">多伦多大学</p>
                    <p class="p2">University of Toronto</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/52.jpg" alt="">
                    <p class="p1">艾米丽卡尔艺术与设计学院</p>
                    <p class="p2">Emily Carr Institute of Art Design</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/53.jpg" alt="">
                    <p class="p1">温哥华电影学院</p>
                    <p class="p2">Vancouver Film School</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/54.jpg" alt="">
                    <p class="p1">安大略设计学院</p>
                    <p class="p2">OCAD University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/55.jpg" alt="">
                    <p class="p1">约克大学</p>
                    <p class="p2">York University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/56.jpg" alt="">
                    <p class="p1">阿尔伯塔艺术与设计学院</p>
                    <p class="p2">Alberta College of Art and Design</p>
                </div>
            </div>
            <!-- 6 -->
            <div class="l2_cont">
                <div class="l2_item">
                    <img src="../img/lxgl/61.jpg" alt="">
                    <p class="p1">皇家墨尔本理工大学</p>
                    <p class="p2">Royal Melbourne Institute of Technology University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/62.jpg" alt="">
                    <p class="p1">墨尔本大学</p>
                    <p class="p2">The University of Melbourne</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/63.jpg" alt="">
                    <p class="p1">新南威尔士大学</p>
                    <p class="p2">The University of New South Wales</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/64.jpg" alt="">
                    <p class="p1">悉尼大学</p>
                    <p class="p2">The University of Sydney</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/65.jpg" alt="">
                    <p class="p1">莫纳什大学</p>
                    <p class="p2">Monash University</p>
                </div>
                <div class="l2_item">
                    <img src="../img/lxgl/66.jpg" alt="">
                    <p class="p1">澳洲国立大学</p>
                    <p class="p2">The Australian National University</p>
                </div>
            </div>

            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="lxgl_btn">如何上艺术名校？</a>
        </div>
        <div class="lxgl3">
            <img src="../img/lxgl/2.png" alt="">
        </div>

        <div class="lxgl4">
            <div class="section_title">
                <p class="section_cn">方案推荐</p>
                <p class="section_en">PROJECT RECOMMENDATION</p>
            </div>
            <div class="courses2">
                <div class="c2_cont">
                    <div class="c2_item cn">
                        <p class="c2_p1">VIP院校计划</p>
                        <p class="c2_p2">适合人群：</p>
                        <p class="c2_p3">申请艺术设计院校本科、研究生的学生</p>
                        <div class="c2_img_box">
                            <img src="../img/艺术课程/Rectangle 155.jpg" alt="" class="c2_img">
                            <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                            <div class="c2_hid_box">
                                <ul>
                                    <li><span></span>定制化全套作品集课程</li>
                                    <li><span></span>海外教授多V1辅导</li>
                                    <li><span></span>欧美权威专业TOP3、TOP5、TOP8名校OFFER</li>
                                    <li><span></span>梦校直通车</li>
                                </ul>
                                <div class="kefu_btn">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="c2_item cn">
                        <p class="c2_p1">专业作品集辅导</p>
                        <p class="c2_p2">适合人群：</p>
                        <p class="c2_p3">已具备基础课能力的学生，计划申请艺术设计院校本科、研究生</p>
                        <div class="c2_img_box">
                            <img src="../img/艺术课程/Rectangle 156.jpg" alt="" class="c2_img">
                            <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                            <div class="c2_hid_box">
                                <ul>
                                    <li><span></span>多名艺术导师量身制定作品集产出</li>
                                    <li><span></span>海外高等院校教学模式</li>
                                    <li><span></span>四级教学法+五维审核体系</li>
                                    <li><span></span>多元化竞赛资源</li>
                                </ul>
                                <div class="kefu_btn">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="c2_item c2_item3 cn">
                        <p class="c2_p1">海外游学与夏校项目</p>
                        <p class="c2_p2">适合人群：</p>
                        <p class="c2_p3">15周岁以上高中或大学生</p>
                        <div class="c2_img_box">
                            <img src="../img/艺术课程/Rectangle 157.jpg" alt="" class="c2_img">
                            <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                            <div class="c2_hid_box">
                                <ul>
                                    <li><span></span>与海外导师合作，独家定制课程</li>
                                    <li><span></span>沉浸式体验，探索灵感来源</li>

                                    <li><span></span>实际前往院校，深入名校课堂</li>
                                </ul>
                                <div class="kefu_btn">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="c2_item c2_item4 cn">
                        <p class="c2_p1">BTEC艺术设计预科</p>
                        <p class="c2_p2">适合人群：</p>
                        <p class="c2_p3">16周岁及以上，高中毕业或在读学生</p>
                        <div class="c2_img_box">
                            <img src="../img/艺术课程/Rectangle 158.jpg" alt="" class="c2_img">
                            <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                            <div class="c2_hid_box">
                                <ul>
                                    <li><span></span>官方认证BTEC办学&考试中心</li>
                                    <li><span></span>本科直录核心课程</li>
                                    <li><span></span>提前适应国外艺术教育模式</li>
                                    <li><span></span>证书全球认可、学分终身有效</li>
                                </ul>
                                <div class="kefu_btn">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="c2_item cn">
                        <p class="c2_p1">A-Level课程</p>
                        <p class="c2_p2">适合人群：</p>
                        <p class="c2_p3">16-19 周岁（ 初中毕业 / 高中在读 ）</p>
                        <div class="c2_img_box">
                            <img src="../img/艺术课程/Rectangle 159.jpg" alt="" class="c2_img">
                            <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                            <div class="c2_hid_box">
                                <ul>
                                    <li><span></span>官方认证的A Level办学&考试中心</li>
                                    <li><span></span>为英联邦艺术留学申请定制</li>
                                    <li><span></span>灵活的选课机制助学生扬长避短</li>
                                    <li><span></span>开设多门艺术学科，多维度拓展艺术领域知识</li>
                                </ul>
                                <div class="kefu_btn">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="c2_item cn">
                        <p class="c2_p1">GA&GD创意基础课</p>
                        <p class="c2_p2">适合人群：</p>
                        <p class="c2_p3">12-16周岁</p>
                        <div class="c2_img_box">
                            <img src="../img/艺术课程/Rectangle 160.jpg" alt="" class="c2_img">
                            <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                            <div class="c2_hid_box">
                                <ul>
                                    <li><span></span>艺术设计启蒙课程</li>
                                    <li><span></span>启发并引导自主的艺术创作</li>
                                    <li><span></span>系统地培养艺术思维</li>
                                    <li><span></span>提升艺术审美与创造力</li>
                                </ul>
                                <div class="kefu_btn">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                            src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="majors1 lxgl5">
            <div class="section_title wow bounceInLeft">
                <p class="section_cn">热门专业</p>
                <p class="section_en">POPULAR MAJORS</p>
            </div>
            <div class="lxgl5_cont">
                <div class="lxgl5_item" @click="majorDetail(0)">
                    <img src="../img/热门专业切图/Group 518.png" alt="">
                    <div class="lxgl5_item_pbox">
                        <p class="p1">服装设计</p>
                        <p class="p2">FASHION</p>
                        <p class="p2">DESIGN</p>
                    </div>
                </div>
                <div class="lxgl5_item" @click="majorDetail(1)">

                    <img src="../img/热门专业切图/Group 519.png" alt="">

                    <div class="lxgl5_item_pbox">

                        <div class="p1">景观设计</div>
                        <p class="p2">LANDSCAPE</p>
                        <p class="p2">DESIGN</p>


                    </div>
                </div>
                <div class="lxgl5_item" @click="majorDetail(2)">

                    <img src="../img/热门专业切图/Group 512.png" alt="">

                    <div class="lxgl5_item_pbox">
                        <p class="p1">工业设计</p>
                        <p class="p2">INDUSTRIAL</p>
                        <p class="p2">DESIGN</p>
                    </div>


                </div>
                <div class="lxgl5_item" @click="majorDetail(3)">

                    <img src="../img/热门专业切图/Group 513.png" alt="">

                    <div class="lxgl5_item_pbox">

                        <div class="p1">插画设计</div>
                        <p class="p2">ILLUSTRATION</p>
                        <p class="p2">DESIGN</p>


                    </div>
                </div>

                <div class="lxgl5_item" @click="majorDetail(4)">
                    
                        <img src="../img/热门专业切图/Group 514.png" alt="">
                  
                    <div class="lxgl5_item_pbox">
                        
                            <div class="p1">动画设计</div>
                            <p class="p2">ANIMATION</p>
                            <p class="p2">DESIGN</p>
                     

                    </div>
                </div>
                <div class="lxgl5_item" @click="majorDetail(5)">
                    <div class="lxgl5_item_top">
                        <img src="../img/热门专业切图/Group 515.png" alt="">
                    </div>
                    <div class="lxgl5_item_pbox">
                     
                            <div class="p1">建筑设计</div>
                            <p class="p2">ARCHITECTURE</p>
                            <p class="p2">DESIGN</p>
                       

                    </div>
                </div>
                <div class="lxgl5_item" @click="majorDetail(6)">
                    <div class="lxgl5_item_top">
                        <img src="../img/热门专业切图/Group 516.png" alt="">
                    </div>
                    <div class="lxgl5_item_pbox">
                        
                            <div class="p1">交互设计</div>
                            <p class="p2">INTERACTION</p>
                            <p class="p2">DESIGN</p>
                        

                    </div>
                </div>
                <div class="lxgl5_item" @click="majorDetail(7)">
                    <div class="lxgl5_item_top">
                        <img src="../img/热门专业切图/Group 517.png" alt="">
                    </div>
                   
                        <div class="lxgl5_item_pbox">
                            <div class="p1">室内设计</div>
                            <p class="p2">INTERIOR</p>
                            <p class="p2">DESIGN</p>
                        </div>

                </div>

            </div>
            <div class="l5_img">
                <img class="l5_item_img" src="../img/lxgl/11.png" alt="">
                <img class="l5_item_img" src="../img/lxgl/112.jpg" alt="">
            </div>

            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="lxgl_btn">如何选择合适的专业？</a>

        </div>
        <div class="a5">
            <!-- <div class="section_title">
                <span class="section_cn">官方资料参考</span>
                <p class="section_en"></p>
            </div> -->
            <div class="section_title">
                <p class="section_cn">热门问答</p>
                <p class="section_en">POPULAR Q&A</p>
            </div>
            <div class="a5_cont">
                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(0)">
                        <div class="a5_item_show_title">Q：跨专业申请珠宝设计，需要做哪些准备？</div>
                        <div class="cha" style="transform: rotate(225deg);">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>

                    <div class="grid" style="grid-template-rows: 1fr;">

                        <div class="a5_item_hid">
                            A：跨专业申请珠宝设计研究生时，目标院校会默认你已经具备了珠宝设计本科生所学的技能。（国外珠宝设计本科课程注重学生的基础技能、设计创意、Critical
                            Thinking以及在做设计项目时的思维逻辑性。会系统地训练学生珠宝制作手工技能、绘图技能、软件技能、设计创新能力以及如何创立一个品牌并且对品牌进行运营营销技能等等。）所以转专业学珠宝设计的同学，需要在读研前补充学习珠宝设计的基础知识以及学习珠宝首饰制作基本的金属制作工艺。
                        </div>


                    </div>
                </div>

                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(1)">
                        <div class="a5_item_show_title">Q：对于时尚管理专业，全球顶尖院校有哪些可以选择呢？</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">
                            A：伦敦艺术大学-伦敦时装学院（专业：MA Fashion Design Management / MA Fashion Retail Management / MA Strategic
                            Fashion Marketing / MA Fashion Entrepreneurship and Innovation）、南安普顿大学（专业：BA (Hons) Fashion
                            Marketing/Management / MA Fashion Management / MA Fashion Marketing and Branding
                            ）、帕森斯设计学院（专业：MPS Fashion Management）、纽约时装设计学院（专业：Fashion Business Management / MPS Global
                            Fashion Management）、萨凡纳艺术与设计学院（BFA Fashion Marketing and Management / MA/MFA Luxury and Fashion
                            Management）。
                        </div>
                    </div>
                </div>
                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(2)">
                        <div class="a5_item_show_title">Q：申请美国加州艺术学院电影专业，需要做什么准备？</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">
                            A：加州艺术学院电影作品集申请要求：1.不超过10分钟的完整电影作品。2.可提供其他领域的电影/摄像创意作品，有助于帮助考官理解你的创作风格。3.回答以下三个问题：What issues
                            and concerns inform your artmaking practice? Why are you applying to your program at CalArts?
                            What are your artistic goals?</div>
                    </div>
                </div>

                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(3)">
                        <div class="a5_item_show_title">Q：全球动画专业较好的院校有哪些？</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">A：美国：加州艺术学院、罗德岛设计学院、芝加哥艺术学院、萨凡纳艺术与设计学院… /
                            英国：英国皇家艺术学院、伦敦艺术大学-中央圣马丁艺术与设计学院、爱丁堡艺术学院、格拉斯哥美术学院… /加拿大：谢尔丹学院 /日本：东京艺术大学、武藏野美术大学、多摩美术大学、京都精华大学… /
                            法国：Gobelins高布兰学院、法国高等信息传播学院…</div>
                    </div>
                </div>
            </div>
            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="lxgl_btn">在线咨询老师了解更多</a>
        </div>


        <div class="lxgl6">
            <div class="section_title">
                <p class="section_cn">RoSSo录取榜单</p>
                <p class="section_en">RoSSo OFFERLIST</p>
            </div>
            <div class="l6_cont">
                <div class="l6_item" v-for="(item, index) in listSchool">
                    <img :src="'https://public.rossoarts.com/static/uploads/' + item.logo" alt="">
                    <p class="p1">{{ item.cname }}</p>
                    <p class="p2">录取<span>{{ item.admission_num }}</span>人</p>
                </div>
            </div>
            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="lxgl_btn">我也想成为其中一员</a>
        </div>

        <div class="lxgl7">
            <div class="section_title">
                <p class="section_cn">国际师资团队</p>
                <p class="section_en">RoSSo TUTORS</p>
            </div>
            <div class="l7_cont">
                <div class="l7_item" v-for="(item, index) in tutors2Data">
                   <div class="img"> <img :src="'https://public.rossoarts.com/static/uploads/teacher/' + item.avatar" alt=""></div>
                    <div class="div">{{ item.school | schoolAd }}</div>
                    <p class="t3_p1">Prof.{{ item.name }}</p>
                    <p class="t3_p2 cn">{{ item.major }}</p>
                    <p class="t3_p3 cn">{{ item.school | schoolAll }}</p>
                </div>
                <div class="l7_item" v-for="(item, index) in tutors1Data">
                    <div class="img"><img :src="'https://public.rossoarts.com/static/uploads/teacher/' + item.avatar" alt=""></div>
                    <div class="div">{{ item.school | schoolAd }}</div>
                    <p class="t3_p1">{{ item.name }}</p>
                    <p class="t3_p2 cn">{{ item.major }}</p>
                    <p class="t3_p3 cn">{{ item.school | schoolAll }}</p>
                </div>
            </div>
            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="lxgl_btn">了解更多</a>
        </div>
        <!--  -->
    </div>
</template>
<script>
import "@/assets/css/lxgl.css"
import "../assets/css/courses.css";
import "@/assets/css/majors.css"
import "@/assets/css/btec.css"
import axios from "axios"
export default {
    data() {
        return {
            countryData: [
                {
                    time: "11月至次年1月",
                    material: "作品集、1-2本sketchbook",
                    language: "雅思5.5分以上/托福80分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "10月中旬至次年1月中旬",
                    material: "作品集、语言成绩、SAT／ACT",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },

                {
                    time: "9月至次年2月",
                    material: "文书材料、作品集、日语成绩、大学成绩单",
                    language: "日语，成绩需要达到 N1/300分以上",
                    gpa: "大部分院校要求3.2以上",
                    writ: "包括研究计划（论文）、成绩证明书、推荐信等，具体以学校要求为准"
                },
                {
                    time: "12月至次年5月",
                    material: "作品集、德语证明、表格式简历、本科毕业证和学位证",
                    language: "德语，申请时达到B1，入学时达到C1",
                    gpa: "大部分院校要求3.2以上",
                    writ: "具体以学校要求为准"
                },
                {
                    time: "12月至次年2月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "8月至12月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
            ],
            theCountryData: {
                time: "11月至次年1月",
                material: "作品集、1-2本sketchbook",
                language: "雅思5.5分以上/托福80分以上",
                gpa: "大部分院校要求3.0以上",
                writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
            },
            new1Bgc: [
                require("../img/留学资讯切图/yg.jpg"),
                require("../img/留学资讯切图/mg.jpg"),
                require("@/img/留学资讯切图/rb.jpg"),
                require("@/img/留学资讯切图/dg.jpg"),
                require("@/img/留学资讯切图/jnd.jpg"),
                require("@/img/留学资讯切图/adly.jpg"),
            ],
            redSchool: [],
            lxgl5img: [
                require("@/img/lxgl/11.png"),
                require("@/img/lxgl/22.png"),
                require("@/img/lxgl/33.png"),
                require("@/img/lxgl/44.png"),
                require("@/img/lxgl/55.png"),
                require("@/img/lxgl/66.png"),
                require("@/img/lxgl/77.png"),
                require("@/img/lxgl/88.png"),
            ],
            lxgl5img2: [
                require("@/img/lxgl/112.jpg"),
                require("@/img/lxgl/222.jpg"),
                require("@/img/lxgl/332.jpg"),
                require("@/img/lxgl/442.jpg"),
                require("@/img/lxgl/552.jpg"),
                require("@/img/lxgl/662.jpg"),
                require("@/img/lxgl/772.jpg"),
                require("@/img/lxgl/882.jpg"),
            ],
            listSchool: [],
            tutors2Data: [],
            tutors1Data:[],
        }
    },
    created() {
        this.getSchool()
        this.getSchool2()
        this.getTutors2()
        this.getTutors1()
    },
    filters: {
        schoolAd(val) {
            // console.log(val,"teacher val");
            return val.split(",")[1]
            
        },
        schoolAll(val) {
            return val.split(",")[0]
        },
    },
    methods: {
        getTutors2() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstTeacher?category=2&limit=3").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data,6));
                this.tutors2Data = data.data

            })
        },
        getTutors1() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstTeacher?category=1&limit=6").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data,6));
                this.tutors1Data = data.data

            })
        },
        a5Show(val) {
            // console.log(val);
            var cha = document.getElementsByClassName("cha")
            var grid = document.getElementsByClassName("grid")
            // var t6_item_show = document.getElementsByClassName("t6_item_show")
            // var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag
            // console.log(grid[val].style.gridTemplateRows,val);
            if (grid[val].style.gridTemplateRows == "1fr") {
                // 折叠
                // console.log("不出");
                grid[val].style.gridTemplateRows = "0fr";
                cha[val].style.transform = "rotate(0deg)"
                // t6_item_show[val].style.backgroundColor = "#5f9df7"
                // t6_item_show[val].style.border = "none"
                // t6_item_show[val].style.margin = "0px"
                // t6_imgQ[val].style.visibility = "visible"
            } else {
                // 展开
                // console.log("出");
                grid[val].style.gridTemplateRows = "1fr";
                cha[val].style.transform = "rotate(225deg)"
                // t6_item_show[val].style.backgroundColor = "#FB6333"
                // t6_item_show[val].style.border = "2px solid #000"
                // t6_item_show[val].style.margin = "-2px -2px 0 -2px"
                // t6_imgQ[val].style.visibility = "hidden"

            }
        },
        majorDetail(val) {
            var l5_item_img = document.getElementsByClassName("l5_item_img")
            var lxgl5_item = document.getElementsByClassName("lxgl5_item")
            for (var i = 0; i < lxgl5_item.length; i++) {
                lxgl5_item[i].style.borderColor = "#9F9F9F"
            }
            lxgl5_item[val].style.borderColor = "#FB6333"
            l5_item_img[0].src = this.lxgl5img[val]
            l5_item_img[1].src = this.lxgl5img2[val]
        },
        getSchool() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstOffer?limit=6&page=1").then((data) => {
                // console.log(data.data.data);
                this.redSchool = data.data.data
            })
        },
        getSchool2() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstOffer?limit=8&page=1").then((data) => {
                // console.log(data.data.data);
                this.listSchool = data.data.data
            })
        },
        switchCountry(val) {
            // console.log(val);
            var n1_nav_item = document.getElementsByClassName("n1_nav_item")
            var l2_cont = document.getElementsByClassName("l2_cont")
            var new1 = document.getElementsByClassName("new1")
            for (var i = 0; i < n1_nav_item.length; i++) {
                n1_nav_item[i].style.backgroundColor = "transparent"
                l2_cont[i].style.display = "none"
            }

            n1_nav_item[val].style.backgroundColor = "#FB6333"
            this.theCountryData = this.countryData[val]
            new1[0].style.backgroundImage = `url(${this.new1Bgc[val]})`
            l2_cont[val].style.display = "flex"
        },
        moreEnter() {
            // console.log("666");
            n1_main_bottom_item_p2.style.width = "260px"
            n1_main_bottom_item_p2.innerHTML = '申请流程、留学费用、院校推荐...'
        },
        moreLeave() {
            n1_main_bottom_item_p2.style.width = "78px"
            n1_main_bottom_item_p2.innerHTML = '了解更多'
        },
    }
}
</script>